import { useStores } from 'common/hooks/useStores';
import Callback from 'components/login/Callback';
import Error from 'components/login/Error';
import K1Callback from 'components/login/K1Callback';
import K1Login from 'components/login/K1Login';
import Login from 'components/login/Login';
import Logout from 'components/login/Logout';
import Reset from 'components/login/Reset';
import Unauthorized from 'components/login/Unauthorized';
import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router';

const AuthContainer = () => {
    const { authStore } = useStores();
    const [hasLoaded, setHasLoaded] = useState(false);

    useEffect(() => {
        if (hasLoaded) {
            return;
        }

        (async function() {
            await authStore.getAuthenticationSettings();
            setHasLoaded(true);
        })();
    }, []);

    return hasLoaded ? (
        <div className="auth-container container">
            <Routes>
                <Route path={'login/*'} element={<Login />} />
                <Route path={'k1login/*'} element={<K1Login />} />
                <Route path={'logout/*'} element={<Logout />} />
                <Route path={'callback/*'} element={<Callback />} />
                <Route path={'k1callback/*'} element={<K1Callback />} />
                <Route path={'unauthorized/*'} element={<Unauthorized />} />
                <Route path={'reset/*'} element={<Reset />} />
                <Route path={'error/*'} element={<Error />} />
                <Route
                    path="/*"
                    element={
                        <Navigate
                            to={{
                                pathname: '/login'
                            }}
                            state={{
                                redirect: `${location.pathname}${location.search}`
                            }}
                        />
                    }
                />
            </Routes>
        </div>
    ) : null;
};

export default AuthContainer;
